<template>
    <div class="page-container">
        <div class="main-container">
            <div>
                <div class="list-group-item">
                    <div class="input-group">
                        <input class="form-control" type="text" v-model="newRssInputText" placeholder="add an rss url"
                            :disabled="busy" />
                        <div class="input-group-append">
                            <button class="btn btn-primary" @click="addNewRssClicked" :disabled="busy">+</button>
                        </div>
                    </div>
                </div>
                <div class="list-group-item text-left" v-for="(subscription, i) in subscriptions" :key="i">
                    <div class="row">
                        <div class="col">
                            <div class="underflow">{{ subscription.title }}</div>
                            <div class="underflow text-secondary">{{ subscription.url }}</div>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-sm" :disabled="subscription.busy"
                                :class="{ 'btn-success': subscription.preferences.showNotifications, 'btn-warning': !subscription.preferences.showNotifications }"
                                @click="showNotifications(subscription)">
                                <span class="fas fa-regular fa-eye"></span>
                            </button>
                            <button class="btn btn-sm" :disabled="subscription.busy"
                                :class="{ 'btn-success': subscription.preferences.includeInFeed, 'btn-warning': !subscription.preferences.includeInFeed }"
                                @click="includeInFeed(subscription)">
                                <span class="fas fa-solid fa-rss"></span>
                            </button>
                            <button class="btn btn-sm btn-danger" :disabled="subscription.busy"
                                @click="trash(subscription)">
                                <span class="fas fa-solid fa-trash"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import SubscriptionApi from '../scripts/SubscriptionApi';

const api = new SubscriptionApi();

export default {
    props: {},
    data: () => ({
        subscriptions: [],
        newRssInputText: '',
        busy: true
    }),
    async mounted() {
        await this.refreshSubscriptions();
        this.busy = false;
    },
    methods: {
        async trash(sub) {
            if (sub.busy)
                return;
            sub.busy = true;

            let confirmedDelete = confirm(`are you sure you want to delete "${sub.title}"?`);
            if (confirmedDelete) {
                await api.removeSubscription(sub.url);
                let subs = this.subscriptions.filter(s => s.url != sub.url);
                this.subscriptions = [];
                this.subscriptions.push(...subs);
            }

            sub.busy = false;
        },
        async includeInFeed(sub) {
            if (sub.busy)
                return;
            sub.busy = true;

            console.log(sub);
            sub.preferences.includeInFeed = !sub.preferences.includeInFeed;
            await api.updatePreferences(sub.url, sub.preferences.includeInFeed, sub.preferences.showNotifications);
            console.log(sub);

            sub.busy = false;
        },
        async showNotifications(sub) {
            if (sub.busy)
                return;
            sub.busy = true;

            sub.preferences.showNotifications = !sub.preferences.showNotifications;
            await api.updatePreferences(sub.url, sub.preferences.includeInFeed, sub.preferences.showNotifications);

            sub.busy = false;
        },
        async addNewRssClicked() {
            if (this.busy)
                return;
            this.busy = true;

            await api.addSubscription(this.newRssInputText);
            await this.refreshSubscriptions();

            this.busy = false;
        },
        async refreshSubscriptions() {
            let subs = await api.getSubscriptions();
            subs.forEach(s => s.busy = false);

            subs.sort((a, b) => a.title.localeCompare(b.title));

            this.subscriptions = [];
            this.subscriptions.push(...subs);
        }
    }
};
</script>

<style scoped>
.btn {
    margin-right: 3px;
}

.btn:last-child {
    margin-right: 0px;
}
</style>